module.exports = __webpack_public_path__ + "img/residenziale.ddcf4dd5.png";